import messages from 'vee-validate/dist/locale/he';

export default {
    messages: {
        ...messages.messages,
        login() {
            return 'המשתמש שצוין אינו קיים.';
        },
        unique() {
            return 'האימייל כבר קיים';
        },
        enabled() {
            return 'The specified user has been disabled.';
        },
        locked() {
            return 'Your access has been restricted. Please contact your Manager.';
        },
    },
    attributes: {
        name: 'שם',
        email: 'דוא"ל',
        password: 'סיסמה',
        passwordConfirmation: 'אשר סיסמה',
    },
};



// WEBPACK FOOTER //
// ./src/lang/he/validator.js